import de from './de.json' with { type: 'json' };
import en from './en.json' with { type: 'json' };

export const claimsI18nNamespace = 'claims' as const;
export const claimsResources = { de, en } as const;
